import Scroller from './modules/Scroller'
// import Marquee from './modules/Marquee'
import Animation from './modules/Animation'
import Contact from './modules/Contact'
import Service from './modules/Service'
import Slider from './modules/Slider'
import Form from './modules/Form'

new Slider()
new Service()
new Contact()
new Scroller()
// new Marquee()
new Animation()
new Form()

const args = ['\n%c Made with ♥ by Stoëmp Studio - https://stoempstudio.com %c\n', 'display: block; padding: 5px 10px; background: #141414; line-height: 40px; color: #ffffff;', 'background: #fff;']
window.console.log.apply(console, args)
